import { render, staticRenderFns } from "./ManageWorkspacePage.vue?vue&type=template&id=2bcc4bba"
import script from "./ManageWorkspacePage.vue?vue&type=script&lang=ts"
export * from "./ManageWorkspacePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports